import { crv, cva } from '@/styled-system/css';

const sizeVariants = crv('size', {
  xs: {
    blockSize: 'auto',
    maxBlockSize: 'none',
    inlineSize: 'auto',
    maxInlineSize: 'none',
    paddingBlock: 'layout.looser',
    paddingInline: 'layout.tight',
  },
  sm: {
    blockSize: 'auto',
    maxBlockSize: 'none',
    inlineSize: 'auto',
    maxInlineSize: 'none',
    paddingBlock: 'layout.looser',
    paddingInline: 'layout.tight',
  },
  md: {
    blockSize: 'auto',
    maxBlockSize: 'none',
    inlineSize: 'auto',
    maxInlineSize: 'none',
    paddingBlock: 'layout.looser',
    paddingInline: 'layout.tight',
  },
  lg: {
    blockSize: 'auto',
    maxBlockSize: 'none',
    inlineSize: 'auto',
    maxInlineSize: 'none',
    paddingBlock: 'layout.looser',
    paddingInline: 'layout.tight',
  },
  xl: {
    blockSize: 'auto',
    maxBlockSize: 'none',
    inlineSize: 'auto',
    maxInlineSize: 'none',
    paddingBlock: 'layout.looser',
    paddingInline: 'layout.tight',
  },
  fullScreen: {
    blockSize: '100%',
    maxBlockSize: '100%',
    inlineSize: '100%',
    maxInlineSize: '100%',
    paddingBlock: 'Modal.Backdrop.padding.fullScreen.vert',
    paddingInline: 'Modal.Backdrop.padding.fullScreen.horz',
  },
});

export const modalBackdropRecipe = cva({
  base: {
    display: 'grid',
    placeItems: 'center',
    zIndex: 'modal',
    animation: 'fade 0.2s ease-out',

    _before: {
      content: '""',
      position: 'fixed',
      inset: 0,
      backgroundColor: 'bg.screen.scrim',
      opacity: 'dialogScrim',
      zIndex: 1,
    },
  },
  variants: {
    scrollDocument: {
      true: {
        // Sets top position to be top, instead of center of viewport
        alignItems: 'start',
        // Switches from `grid` to `flex` to remove padding collapse
        display: 'flex',
        // Centers the content in the viewport
        justifyContent: 'center',
      },
      false: {},
    },
    ...sizeVariants,
  },
});
